import ShareDocument from './ShareDocument';

export default ShareDocument;
